import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';


const BannerTourList = (propsData) => {
    const { t } = useTranslation();
    const [startDate, setStartDate] = useState(new Date());
    const [isLoading, setIsLoading] = useState(true);



    // ******Search********
    const [searchTerm, setSearchTerm] = useState();
    const [searchDate, setSearchDate] = useState();
    const navigate = useNavigate();

    const changeValue = (event) => {
        setSearchTerm(event.target.value)
    }

    const searchForm = (event) => {
        event.preventDefault();
        navigate(`/search/${searchTerm}`, { state: { propsDate: searchDate } });
    }

    const formatedDate = (date) => {
        const fixedDate = date.toLocaleDateString('en-CA'); // y-m-d formatında tarih dönüşümü
        setSearchDate(fixedDate)
    };

    // ********************
    // **********HomeBanner*********
    const data = propsData.propsData;

    useEffect(() => {
        if (data) {
            setIsLoading(false);
        }
    }, [data]);
    // *******decode******
    const decodedData = atob(data.description);
    const textDecoder = new TextDecoder('utf-8');
    const decodedDescription = textDecoder.decode(new Uint8Array(decodedData.split('').map(char => char.charCodeAt(0))));
    // ************
    if (isLoading) {
        return ""
    };
    return (
        <div className="bannerbgvd">
            <div className='bannerbgvideocontainer tourListBanner' style={{ backgroundImage: `url(${data.datas[0].image})` }}>
                <div className="d-flex align-items-center h-100 TourListMTbanner">
                    <div className="w-100">

                        <div className='tourListBannerPaddingTop' style={{ paddingTop: "5%" }}>
                            <div className="bannerbaslik">{data.title}</div>
                            <div className='mt-3 text-white fnt14px' style={{ maxWidth: "800px" }}>{decodedDescription}</div>
                            {/* <div className='pt-5 tourListBannerFlex'>
                                <button className='btn p-3 bannerbtnwhite'><strong>View Rates</strong></button>
                                <Link to={`/tourdetail`} className='custom-link'><button className='btn p-3 mx-4 bannerbtnblack'>Tour Details</button></Link>
                            </div> */}
                        </div>
                        <div className="bannersearchvd pt-3 pb-3 px-5">
                            <div className="row">
                                <div className="col-md-4 col-xs-12 col-sm-12 borderright1 mediaQueryBorderBanner mqW-100">
                                    <div className="mb-1 mt-2 text-white"><i className="fas fa-map-marker-alt"></i><span className="px-2 fnt14px">{t('anywhere')}</span></div>
                                    <div>
                                        <input
                                            type="text"
                                            className="bannerinput"
                                            placeholder={t('takeYou')}
                                            onChange={changeValue}
                                        />

                                    </div>
                                </div>
                                <div className="col-md-4 col-xs-12 col-sm-12 px-5 datePadding  mqW-100">
                                    <div className="mb-1 mt-2 text-white"><i className="fas fa-calendar"></i><span className="px-2 fnt14px">{t('date')}</span></div>
                                    <div>
                                        <DatePicker
                                            selected={searchDate ? new Date(searchDate) : null}
                                            className="bannerinput"
                                            onChange={(date) => formatedDate(date)}
                                            minDate={new Date()}
                                            timeIntervals={15}
                                            timeCaption="time"
                                            dateFormat="MMMM d, yyyy"
                                            popperPlacement="top-start"
                                            placeholderText={t('validation.selectDate')}

                                        />
                                    </div>
                                </div>
                                <div className="col-md-4 col-xs-12 col-sm-12 mqW-100">
                                    <div className='d-flex align-items-center h-100'>
                                        <div className='w-100'>
                                            <button className='btn bg-white w-100 p-3' onClick={searchForm} style={{ borderRadius: "60px", fontWeight: "600", fontSize: "18px" }}>{t('search')}</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>




    );

}

export default BannerTourList